import { useState, useRef, useEffect } from "react";
import styles from "./CurrencyDropdown.module.scss";
import ArrowDown from "../../assets/images/svgs/ArrowDown";
import { useCurrencies } from "../../context/CurrenciesContext";

const CurrencyDropdown = () => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const { currencies, currency, setCurrency, setCurrencyId } = useCurrencies();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleCurrencySelect = (value: string, id: number) => {
    setCurrency(value);
    setCurrencyId(id);
    setOpenDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!currencies || currencies.length === 0) {
    return null;
  }

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <button
        className={styles.dropdown_btn}
        onClick={toggleDropdown}
        type="button"
      >
        <span>{currency || "Select Currency"}</span>
        {currencies.length > 1 && <ArrowDown />}
      </button>
      {currencies.length > 1 && (
        <div
          className={`${styles.dropdown_menu} ${
            openDropdown ? styles.show : ""
          }`}
        >
          {currencies.map((cur) => (
            <div
              key={cur.id}
              onClick={() => handleCurrencySelect(cur.name, cur.id)}
              className={`${styles.dropdown_item} ${
                currency === cur.name ? styles.active : ""
              }`}
            >
              {cur.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencyDropdown;
